
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from '@/components/ui/scroll-area';
import { AddTaskForm } from '../AddTaskForm';

interface Template {
  id: string;
  title: string;
  description: string | null;
  hebrew_title: string | null;
  hebrew_description: string | null;
}

interface EditTemplateFormProps {
  template: Template;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: any) => void;
}

export const EditTemplateForm = ({ template, open, onOpenChange, onSubmit }: EditTemplateFormProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] bg-[#1A1F2C] border-[#403E43] text-white" dir="rtl">
        <DialogHeader>
          <DialogTitle className="text-white text-right">עריכת תבנית</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[60vh] pr-4">
          <AddTaskForm
            onSubmit={onSubmit}
            initialData={{
              id: template.id,
              title: template.title,
              description: template.description || '',
              hebrewTitle: template.hebrew_title || '',
              hebrewDescription: template.hebrew_description || '',
              isCompleted: false,
              createdAt: new Date(),
              scheduledDay: null,
              coins: 0  // Adding the missing coins property with default value 0
            }}
          />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
